var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import styled from "styled-components";
import { InputBase, FormControl, FormHelperText, Button } from "@mui/material";
export var Container = styled(FormControl)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
export var Input = styled(InputBase)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n  padding: 1rem;\n  height: 46px;\n  width: 100%;\n  box-sizing: inherit;\n  border-radius: 0.8rem;\n  position: relative;\n  background-color: ", ";\n  border: 0.2rem solid\n    ", ";\n\n  @media ", " {\n    height: 49px;\n  }\n\n  &.Mui-focused {\n    border: 0.2rem solid\n      ", ";\n  }\n\n  .MuiInputBase-input {\n    ", ";\n\n    color: ", ";\n    transition: border-color 0.25s linear;\n    appearance: none;\n    text-overflow: ellipsis;\n    text-align: left;\n\n    &::placeholder {\n      font-size: 1.7rem;\n      font-style: italic;\n      color: ", ";\n      opacity: 1;\n\n      @media ", " {\n        color: ", ";\n      }\n    }\n  }\n\n  .MuiInputBase-inputMultiline {\n    overflow-y: auto;\n    overflow-x: hidden;\n  }\n"], ["\n  width: 100%;\n  padding: 1rem;\n  height: 46px;\n  width: 100%;\n  box-sizing: inherit;\n  border-radius: 0.8rem;\n  position: relative;\n  background-color: ", ";\n  border: 0.2rem solid\n    ", ";\n\n  @media ", " {\n    height: 49px;\n  }\n\n  &.Mui-focused {\n    border: 0.2rem solid\n      ", ";\n  }\n\n  .MuiInputBase-input {\n    ", ";\n\n    color: ", ";\n    transition: border-color 0.25s linear;\n    appearance: none;\n    text-overflow: ellipsis;\n    text-align: left;\n\n    &::placeholder {\n      font-size: 1.7rem;\n      font-style: italic;\n      color: ", ";\n      opacity: 1;\n\n      @media ", " {\n        color: ", ";\n      }\n    }\n  }\n\n  .MuiInputBase-inputMultiline {\n    overflow-y: auto;\n    overflow-x: hidden;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.color.white;
}, function (_a) {
    var theme = _a.theme, error = _a.error;
    return (error ? theme.color.blood : theme.color.coolGray);
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.minMD;
}, function (_a) {
    var theme = _a.theme, error = _a.error;
    return error ? theme.color.blood : theme.color.fakeBlack;
}, function (_a) {
    var theme = _a.theme;
    return (__assign({}, theme.typography.body1));
}, function (_a) {
    var theme = _a.theme;
    return theme.color.fakeBlack;
}, function (_a) {
    var theme = _a.theme;
    return theme.color.smoke;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.minXS;
}, function (_a) {
    var theme = _a.theme;
    return theme.color.smoke;
});
export var FeedBackMessage = styled(FormHelperText)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 100%;\n\n  && {\n    ", ";\n    font-style: normal;\n    font-weight: normal;\n    color: ", ";\n    text-align: left;\n    margin: 0.8rem 0 0;\n  }\n"], ["\n  width: 100%;\n\n  && {\n    ", ";\n    font-style: normal;\n    font-weight: normal;\n    color: ", ";\n    text-align: left;\n    margin: 0.8rem 0 0;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return (__assign({}, theme.typography.caption1));
}, function (_a) {
    var theme = _a.theme;
    return theme.color.blood;
});
export var ButtonStyled = styled(Button)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  && {\n    text-transform: none;\n  }\n"], ["\n  && {\n    text-transform: none;\n  }\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
